export default function px(value) {
    let number = Number(value);

    if (value.includes('px')) {
        number = Number(value.trim().slice(0, value.indexOf('px')));
    }

    if (Number.isNaN(number)) {
        return value;
    }

    return `${ number / 16 }rem`;
}
